var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-box"},[_c('img',{staticClass:"error-img",attrs:{"src":require("images/icon/error-icon.png")}}),_c('div',{staticClass:"error-text"},[_vm._v("您已对接库存中心实时库存，无该菜单操作权限！")])])])
}]

export { render, staticRenderFns }